import React from "react";
var SearchContext = React.createContext();
export default SearchContext;